<script lang="ts" setup>
import Slide from './components/sliders/index.vue'
import Brain from './components/brain/index.vue'
</script>

<template>
  <div>
    <Slide />
    <Brain />
  </div>
</template>

<style scoped></style>
